import { css } from 'styled-components';
export var commonStyles = css(["position:relative;flex-shrink:0;overflow:hidden;width:", "px;height:", "px;border-radius:2px;", ";"], function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var margin = _ref3.margin;
  return margin && "margin: ".concat(margin, ";");
});